import { onMounted, onUnmounted } from 'vue'
import store from '@/js/store'

let updateCheckInterval = null

export function useServiceWorkerUpdates() {
	onMounted(() => {
		if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
			// Check for updates at regular intervals.
			updateCheckInterval = setInterval(() => {
				// Don't check for updates if user is on List Entry pages to avoid interrupting form processing.
				if (!store.state.appUpdateCheckingIsPaused) {
					navigator.serviceWorker.getRegistration().then((registration) => {
						if (registration) {
							registration.update()
						}
					})
				}
			}, 1000 * 60 * 60 * 8)
		}
	})

	onUnmounted(() => {
		if (updateCheckInterval) {
			clearInterval(updateCheckInterval)
			updateCheckInterval = null
		}
	})
}
